import { Vendor } from '@/types/resources/vendor';
import dayjs from 'dayjs';

const WORKSPACE_ID = 'demo-workspace';
const createWorkspaceRef = () => ({
  id: WORKSPACE_ID,
  name: 'Jardines del Atardecer',
  slug: 'demo-workspace',
});

const categories = ['Plomería', 'Electricidad', 'Jardinería', 'Catering', 'Servicios de Seguridad', 'Soporte IT', 'Control de Plagas', 'Gestión de Residuos'];
const companyNames = [
  'Soluciones Apex', 'Servicios Estelares', 'Innovar Inc.', 'Co. Salto Cuántico', 'Grupo Vertex',
  'Proveedores Pinnacle', 'Sistemas Sinergia', 'Contratistas Blue-Ribbon', 'Obras Zenith', 'Empresas Fusión',
  'Eléctricos Evergreen', 'Plomeros AquaFlow', 'Jardinería GreenScape', 'Co. Catering Gourmet', 'Seguridad Fortaleza',
  'IT TechGenius', 'Control de Plagas BugBusters', 'Gestión de Residuos EcoClean', 'Mantenimiento Pro-Tech', 'Reparaciones Confiables'
];

export const vendors: Vendor[] = Array.from({ length: 50 }, (_, idx) => {
  const companyName = companyNames[idx % companyNames.length];
  const category = categories[idx % categories.length];
  
  return {
    id: `VEND-${(idx + 1).toString().padStart(3, '0')}`,
    type: 'service_provider',
    status: idx % 10 === 0 ? 'inactive' : 'active',
    name: `${companyName} #${idx + 1}`,
    contactPerson: `Persona de Contacto ${idx + 1}`,
    category: category,
    email: `contact.person.${idx + 1}@${companyName.toLowerCase().replace(/ /g, '')}.com`,
    phone: `+1-555-0200-${idx}`,
    address: `${100 + idx} Parque Empresarial, Suite 100, Ciudad Demo`,
    services: [category],
    paymentTerms: 'net30',
    workspace: createWorkspaceRef(),
    activityRecords: [{
      timestamp: dayjs().subtract(Math.floor(Math.random() * 30), 'days').toDate(),
      type: 'created',
      performedBy: { id: 'admin-001', displayName: 'Gerente de Propiedad' }
    }]
  };
}); 